import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logoImage from '../assets/images/Milkocheck_logo.png';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Clear form fields on component mount
  useEffect(() => {
    setUsername('');
    setPassword('');
    setError('');
  }, []);

  useEffect(() => {
    // Clear form fields when user logs out (user becomes null)
    if (!user) {
      setUsername('');
      setPassword('');
      setError('');
    } else {
      // If user is already logged in, redirect
      redirectUser(user.role);
    }
  }, [user]);

  const redirectUser = (role) => {
    const routes = {
      superadmin: '/superadmin',
      client: '/client',
      manager: '/manager',
      employee: '/employee'
    };
    navigate(routes[role] || '/login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const result = await login(username, password);
    if (result.success && result.user) {
      // Clear form fields after successful login
      setUsername('');
      setPassword('');
      redirectUser(result.user.role);
    } else {
      setError(result.message);
      // Clear password field on error for security
      setPassword('');
    }
  };

  return (
    <div className="login-container">
      <img src={logoImage} alt="Milkocheck" className="login-logo-top" />
      <div className="login-layout">
        <div className="login-welcome-section">
          <div className="welcome-content">
            <h1 className="welcome-title">Welcome Back</h1>
            <p className="welcome-subtitle">
              Sign in to access your dashboard and manage your account
            </p>
            <div className="welcome-features">
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Secure and reliable platform</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Easy data management</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>24/7 customer support</span>
              </div>
            </div>
          </div>
        </div>
        <div className="login-form-section">
          <div className="login-header">
            <h2>Login</h2>
            <p className="login-subtitle">Enter your credentials to access your account</p>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <div className="input-wrapper">
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  placeholder="Username"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  placeholder="Password"
                  required
                />
              </div>
            </div>
            <button type="submit" className="login-button">
              <span>Login</span>
            </button>
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

